@if (project$ | async; as project) {
<app-add-edit-project
  [submitText]="createNew ? 'Create project' : 'Save'"
  [project]="project"
  (projectSubmitted)="Submit($event)"
  (cancel)="Cancel()"
>
</app-add-edit-project>
}
